import styled from 'styled-components';
import { RenderAndRecurseChildren } from './RenderAndRecurseChildren';

export const SitemapPage = ({ data }) => {
  return (
    <SitemapPage.Wrapper>
      <RenderAndRecurseChildren data={data} />
    </SitemapPage.Wrapper>
  );
};

SitemapPage.Wrapper = styled.div`
  margin: 20px;
`;
